module.exports = __webpack_public_path__ + "static/media/Frame3.ed8bd3f4.png";